<template>
  <div>
    <div class="row wrapper border-bottom white-bg page-heading">
      <div class="col-xs-9">
        <h2>Activities Calendar</h2>
        <p>Click on the activity block to view details.</p>
      </div>
      <div
           id="list-calendar"
           class="mobile-hide col-xs-3 text-right">
        <span v-if="isList">
          <span
                class="btn btn-primary btn-md"
                style="line-height: 1.42857143;"
                @click="changeStyle">
            <i class="fa fa-list fa-fw" />
            <strong>Show in calendar</strong>
          </span>
        </span>
        <span v-else>
          <span
                class="btn btn-primary btn-md"
                style="line-height: 1.42857143;"
                @click="changeStyle">
            <i class="fa fa-calendar fa-fw" />
            <strong>Show in list</strong>
          </span>
        </span>
        <!-- span :class="{'fa fa-list':isList, 'fa fa-calendar':!isList}"
        @click="changeStyle"></span-->
      </div>
      <div class="col-xs-3 mobile-show pull-right">
        <div
             id="list-calendar-mobile"
             class="mobile-show pull-right">
          <span v-if="isList">
            <span
                  class="btn btn-primary btn-xs fa fa-list fa-fw"
                  style="line-height: 1.42857143;"
                  @click="changeStyle">
              <strong>Show in calendar</strong>
            </span>
          </span>
          <span v-else>
            <span
                  class="btn btn-primary btn-xs fa fa-calendar fa-fw"
                  style="line-height: 1.42857143;"
                  @click="changeStyle">
              <strong>Show in list</strong>
            </span>
          </span>
        </div>
      </div>
    </div>
    <div class="wrapper wrapper-content">
      <div :class="{'row animated fadeInDown':true, 'hide':isList}">
        <div
             id="calendar"
             class="col-lg-12">
          <div class="ibox float-e-margins">
            <div class="ibox-content">
              <full-calendar
                             ref="calendar"
                             :config="config"
                             @event-selected="eventClick" />
            </div>
          </div>
        </div>
      </div>
      <div :class="{'row animated fadeInDown':true, 'hide':!isList}">
        <div class="col-xs-12">
          <div class="col-xs-12">
            <div
                 v-for="event in futureEvents"
                 :key="event.id"
                 :id="`event-${event.id}`">
              <a
                 class="col-xs-12 event-list"
                 @click="eventClick(event)">
                <div class="col-xs-6 event">
                  <span class="ng-binding">{{ event.name }}</span>
                </div>
                <div class="col-xs-5 schedule">
                  <span
                        class="date ng-binding">{{ event.start_time | moment("YYYY-MM-DD HH:mm:ss") }}</span> ~
                  <span
                        class="time ng-binding">{{ event.end_time | moment("YYYY-MM-DD HH:mm:ss") }}</span>
                </div>
                <div class="col-xs-1 lbl-availability">
                  <span
                        class="lbl-count badge ng-binding">{{ event.total_seats - event.registered_count }} / {{ event.total_seats }}</span>
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>
      <div
           id="eventInfoModal"
           class="modal inmodal fade"
           tabindex="-1"
           role="dialog"
           aria-labelledby="eventCreationLabel"
           aria-hidden="true">
        <div
             class="modal-dialog"
             role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5
                  id="eventCreationLabel"
                  class="modal-title">Event Information</h5>
              <button
                      type="button"
                      class="close"
                      data-dismiss="modal"
                      aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <form role="form">
                <div class="form-group">
                  <h2>{{ event.name }}</h2>
                </div>
                <div class="form-group">
                  <p>
                    <b>Activity Location:</b>
                    {{ event.location }}
                  </p>
                </div>
                <div class="form-group">
                  <p>
                    <b>Activity Time:</b>
                    {{ event.start_time | moment("YYYY-MM-DD HH:mm:ss") }} ~
                    {{ event.end_time | moment("YYYY-MM-DD HH:mm:ss") }}
                  </p>
                </div>
                <div class="form-group">
                  <p>
                    <b>Activity Color:</b>
                    <span
                          :style="{background: event.color}"
                          style="padding: 7px;  text-align:
                    center; display: inline-block;"
                          class="m-l-xs" />
                  </p>
                </div>
                <div class="form-group">
                  <span
                        class="nav-label"
                        style="margin-right: 1rem;">
                    <b>Seats Available:</b>
                  </span>
                  <span
                        class="label label-warning">{{ event.total_seats - event.registered_count }}/{{ event.total_seats }}</span>
                </div>
                <div class="form-group">
                  <p style="margin-top: 1rem;">
                    <b>Activity Description:</b>
                    {{ event.description }}
                  </p>
                </div>
                <div class="checkbox m-l-md m-r-md">
                  <input
                         id="putWaitList"
                         v-model="putWaitList"
                         type="checkbox">
                  <label for="putWaitList">
                    Put me in waiting list if no quota left.
                  </label>
                </div>
              </form>
              <div
                   v-show="errorShow"
                   class="toast-top-right"
                   style="margin: 0 0 2%;">
                <div
                     class="toast toast-error"
                     style="opacity: 0.69075;">
                  <div
                       class="toast-message"
                       style="padding: 1%; color: white; font-size: 1.5rem;">This activity cannot be registered: " {{ errorMessage }} "</div>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <div class="row">
                <template v-if="!self_registered">
                  <template v-if="!user.blacklist">
                    <div id="event_control_user">
                      <button
                              type="button"
                              class="btn btn-secondary"
                              data-dismiss="modal">Cancel</button>
                      <button
                              id="eventInfoBtn"
                              class="btn btn-md btn-primary d-block pull-right"
                              @click="enrollActivity">
                        <strong>Register</strong>
                      </button>
                    </div>
                  </template>
                  <template v-else>
                    <div id="event_control_user">
                      <button
                              type="button"
                              class="btn btn-secondary"
                              data-dismiss="modal">Cancel</button>
                      <button
                              disabled
                              class="btn btn-md btn-primary d-block pull-right">
                        <strong>In Blacklist</strong>
                      </button>
                    </div>
                  </template>
                </template>
                <template v-else>
                  <div id="event_control_user">
                    <button
                            type="button"
                            class="btn btn-secondary"
                            data-dismiss="modal">Cancel</button>
                    <button
                            disabled
                            class="btn btn-md btn-primary d-block pull-right">
                      <strong>Registered</strong>
                    </button>
                  </div>
                </template>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import { FullCalendar } from "vue-full-calendar";
import "@/assets/inspinia/font-awesome/css/font-awesome.css";
import { Chrome } from "vue-color";

export default {
  name: "Home",
  components: {
    FullCalendar,
    "chrome-picker": Chrome
  },
  props: {
    user: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      isList: false,
      config: {
        weekends: false,
        editable: false,
        selectable: false,
        businessHours: {
          // days of week. an array of zero-based day of week integers (0=Sunday)
          dow: [1, 2, 3, 4, 5], // Monday - Thursday
          start: "9:00", // a start time (10am in this example)
          end: "18:00" // an end time (6pm in this example)
        },
        minTime: "9:00:00",
        maxTime: "18:30:00",
        slotDuration: "00:15:00",
        slotLabelInterval: "00:30:00",
        height: "auto",
        validRange: function (nowDate) {
          const today = new Date();
          return {
            start: moment()
              .subtract(1, "weeks")
              .isoWeekday(7),
            end: moment()
              .add(2, "weeks")
              .isoWeekday(6)
          };
        },
        timezone: "local"
      },
      events: [],
      event: {
        name: "Activity Name",
        description: "Activity Description",
        startTime: Date.now() / 1000,
        endTime: Date.now() / 1000,
        total_seats: 0,
        registered_count: 0,
        color: "#1ab394"
      },
      self_registered: false,
      errorMessage: "",
      errorShow: false,
      putWaitList: false
    };
  },
  computed: {
    orderedEvents () {
      let newEvents = JSON.parse(JSON.stringify(this.events));
      newEvents.sort(function (a, b) {
        return a.start_time - b.start_time;
      });
      return newEvents;
    },
    firstDayoftheWeek () {
      const d = new Date();
      d.setHours(0, 0, 0, 0);
      var day = d.getDay(),
        diff = d.getDate() - day; // adjust when day is sunday
      return new Date(d.setDate(diff)).getTime() / 1000;
    },
    thisWeekEvents () {
      const f = this.firstDayoftheWeek;
      const l = f + 7 * 24 * 60 * 60;
      return this.orderedEvents.filter(function (a) {
        return a.start_time > f && a.start_time < l;
      });
    },
    futureEvents () {
      const f = Date.now() / 1000;
      return this.orderedEvents.filter(function (a) {
        return a.start_time >= f;
      });
    }
  },
  mounted () {
    this.fetchEvents();
  },
  methods: {
    changeStyle () {
      this.isList = !this.isList;
    },
    eventClick (event) {
      const that = this;
      if (this.user) {
        this.$emit("showLoading");
        window.request
          .get(`event/` + event.id)
          .then(response => {
            that.event = response.data;
            that.event.color = that.event.color || "#1ab394";
            that.errorShow = false
            that.errorMessage = ""
            that.fetchUserRegistrationInfo(event.id);
            $("#eventInfoModal").modal("show");

            $('.i-checks').iCheck({
              checkboxClass: 'icheckbox_square-green',
              radioClass: 'iradio_square-green',
            }).on('ifChecked ifUnchecked', function () {
              $(this)[0].dispatchEvent(new Event("change"));
            });

            that.putWaitList = false
          })
          .catch(error => {
            toastr.error(error);
          })
          .finally(() => {
            that.$emit("hideLoading");
            that.chosenColor = that.event.color;
          });
      }
    },
    fetchEvents () {
      const that = this;
      this.$emit("showLoading");
      window.request
        .get("event")
        .then(response => {
          if (response.data.events) {
            that.events = response.data.events;
            let events = [];
            response.data.events.forEach(event => {
              let s, e;
              s = new Date();
              s.setTime(event.start_time * 1000);
              e = new Date();
              e.setTime(event.end_time * 1000);
              events.push({
                id: event.id,
                title: event.name,
                start: s.toISOStringZoned(),
                end: e.toISOStringZoned(),
                backgroundColor: event.color,
                borderColor: "#ddd"
              });
            });
            let eventSources = {
              events
            };
            that.$refs.calendar &&
              that.$refs.calendar.fireMethod("addEventSource", eventSources);
            console.info("Loaded events:", eventSources);

            const today = new Date();
            if (![0, 6].includes(today.getDay())) {
              that.$refs.calendar &&
                that.$refs.calendar.fireMethod(
                  "gotoDate",
                  moment()
                    .add(1, "weeks")
                    .isoWeekday(1)
                );
            }
          }
        })
        .catch(error => {
          toastr.error(error.response.data.message);
        })
        .finally(() => that.$emit("hideLoading"));
    },
    fetchUserRegistrationInfo (id) {
      const that = this;
      this.$emit("showLoading");
      window.request
        .get(`user/${this.user.id}/registration/${id}`)
        .then(response => {
          that.self_registered = response.data.status;
        })
        .catch(error => {
          toastr.error(error.response.data.message);
        })
        .finally(() => {
          that.$emit("hideLoading");
        });
    },
    enrollActivity () {
      const that = this;
      $("#eventInfoBtn").button("loading");
      this.request
        .post(`event/${this.event.id}/registration`, {
          id: that.user.id,
          waiting_list: that.putWaitList
        })
        .then(function (response) {
          that.errorMessage = "";
          that.errorShow = false;
          toastr.success("Successfully enrolled.");
          that.fetchUserRegistrationInfo(that.event.id);
          setTimeout(function () {
            $("#eventInfoModal").modal("hide");
            console.log("event modification success");
            $("#eventInfoBtn").button("reset");
          }, 500);
        })
        .catch(function (error) {
          that.errorShow = true;
          that.errorMessage =
            error.response.data.message || error.response.data.error;
          $("#eventInfoBtn").button("reset");
        });
    }
  }
};
</script>

<style scoped>
#list-calendar {
  padding: 2% 2% 2% 0;
}

#list-calendar-mobile {
  vertical-align: middle;
  padding-top: 2rem;
  padding-bottom: 2rem;
}

#list-calendar span,
#list-calendar-mobile span {
  cursor: pointer;
}

#event_control .btn {
  margin-bottom: 1rem;
  margin-right: 3rem;
}

@media (max-width: 426px) {
  .mobile-hide {
    display: none;
  }
  #event_control_user {
    padding: 20px 1% 0 0;
  }
}
@media (min-width: 426px) {
  .mobile-show {
    display: none;
  }
  #event_control_user {
    padding: 2% 1% 0 10%;
  }
}
</style>
